import { createAction } from 'redux-actions';
import {
  PAGE_LIST_FETCH,
  PAGE_LIST_SUCCESS,
  PAGE_LIST_FAILURE,
  DELETE_PAGE_FETCH,
  DELETE_PAGE_SUCCESS,
  DELETE_PAGE_FAILURE
} from './actionTypes';
import api from '../../services/api';

//<<<---FETCH-LIST-OF-PAGES--->>>
export const pageListFetch = createAction(PAGE_LIST_FETCH);
export const pageListSuccess = createAction(PAGE_LIST_SUCCESS);
export const pageListFailure = createAction(PAGE_LIST_FAILURE);

export const fetchPages = () => async dispatch => {
  dispatch(pageListFetch());
  try {
    const res = await api.get('page');
    dispatch(pageListSuccess(res.data));
  } catch (error) {
    dispatch(pageListFailure(error));
  }
};

//<<<---DELETE-PAGE--->>>
export const deletePageFetch = createAction(DELETE_PAGE_FETCH);
export const deletePageSuccess = createAction(DELETE_PAGE_SUCCESS);
export const deletePageFailure = createAction(DELETE_PAGE_FAILURE);

export const deletePage = (id, lang, callback) => async dispatch => {
  dispatch(deletePageFetch());
  try {
    const res = await api.post(`page/${id}/${lang}`, undefined, {
      headers: { 'X-HTTP-Method-Override': 'DELETE' }
    });
    dispatch(deletePageSuccess(res.data));
    callback();
  } catch (error) {
    dispatch(deletePageFailure(error));
  }
};



// WEBPACK FOOTER //
// ./src/modules/PageList/actions.js